import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import ic_close from "assets/images/ic_close.svg";

import { GeneralTable } from "components";
import AccountOverviewDropdown from '../accountOverviewDropdown/AccountOverviewDropdown';

import { func_validation, func_datetime } from 'functions';
import { billOverviewColumns } from './billOverviewColumns';


import 'assets/scss/billingPortal/modules/billOverview.scss';



export function BillOverviewPresentation(props) {
    const { invoiceNo, getSpecificInvoiceDetails_requesting, specificInvoiceDetails } = props;

    function getSpecificInvoiceDetails() {
        if (func_validation.isFunction(props.getSpecificInvoiceDetails) &&
            func_validation.isNumberValid(invoiceNo)) 
            props.getSpecificInvoiceDetails(invoiceNo);
    }

    // Overview

    let accountCode = func_validation.getObjectPropertyValue(specificInvoiceDetails, "AccountCode", "");

    let invoiceDate = func_validation.getObjectPropertyValue(specificInvoiceDetails, "IssueDateTime", "");
    invoiceDate = func_validation.isStringTrimNotEmpty(invoiceDate)? invoiceDate:"";

    let documentDateTime = func_validation.getObjectPropertyValue(specificInvoiceDetails, "DocumentDateTime", "");
    let lastSentEmail = func_validation.getObjectPropertyValue(specificInvoiceDetails, "LastSendEmail", "");
    let status = func_validation.getObjectPropertyValue(specificInvoiceDetails, "LastSendEmail", "");
    status = func_validation.isStringTrimNotEmpty(status)? "Sent": "-";

    // Status Color
    let statusIconColor = "billOverview-overviewStatusCell-icon_pending";
    switch (status) {
        case "Sent":
            statusIconColor = "billOverview-overviewStatusCell-icon_success";
            break;
        case "Incomplete":
            statusIconColor = "billOverview-overviewStatusCell-icon_failure";
            break;
        default:
            break;
    }

    // Status Display
    let statusDisplay = "";
    if (status != "-") {
        statusDisplay = (
            <React.Fragment>
                <FontAwesomeIcon
                    className={"billOverview-overviewStatusCell-icon " + statusIconColor} 
                    icon={faCircle}
                />
                <span>{status}</span>
            </React.Fragment>
        )
    }

    let accountOverviewArray =[
        {
            label: "Account Code",
            value: func_validation.isStringTrimNotEmpty(accountCode)? accountCode:""
        },
        {
            label: "Issue Date",
            value: func_datetime.convertDateTimeToLocal(invoiceDate, "DD/MM/YYYY")
        },
        {
            label: "Document Date",
            value: func_datetime.convertDateTimeToLocal(documentDateTime, "DD/MM/YYYY")
        },
        {
            label: "Last Sent Email",
            value: func_datetime.convertDateTimeToLocal(lastSentEmail, "DD/MM/YYYY")
        }
    ];

    // Table    
    let invoiceItems = func_validation.getObjectPropertyValue(specificInvoiceDetails, "InvoiceItems");
    let invoiceItems_formatted = [];
    if (func_validation.isArrayNotEmpty(invoiceItems)) {
        invoiceItems_formatted = invoiceItems.map((itemDetail) => {
            let productCode = func_validation.getObjectPropertyValue(itemDetail, "ProductCode", "");
            let unitPrice = func_validation.getObjectPropertyValue(itemDetail, "UnitPrice", "");
            let frequency = func_validation.getObjectPropertyValue(itemDetail, "frequency", "");
            let chargeMethod = func_validation.getObjectPropertyValue(itemDetail, "ChargeMethod", "");
            let subscriptionMethod = func_validation.getObjectPropertyValue(itemDetail, "SubscriptionMethod", "");
            let unitDiscountAmount = func_validation.getObjectPropertyValue(itemDetail, "UnitDiscountAmount", "");
            let subtotal = func_validation.getObjectPropertyValue(itemDetail, "SubTotal", "");

            let outletDetails = func_validation.getObjectPropertyValue(itemDetail, "InvoiceItemDetails", []);
            let totalOutlets = func_validation.getArrayLength(outletDetails);
            let outlets = (totalOutlets > 0)? totalOutlets + "": "";

            // Get outlet names
            let outletNames = [];
            if (func_validation.isArrayNotEmpty(outletDetails)) {

                outletNames = outletDetails.map((detail) => {
                    let outletName = func_validation.getObjectPropertyValue(detail, "ReferenceValue", "");
                    return outletName;
                });
            }

            let obj = {
                productCode: productCode,
                unitPrice: unitPrice,
                frequency: frequency,
                chargeMethod: chargeMethod,
                outlets: outlets,
                subscriptionMethod: subscriptionMethod,
                unitDiscountAmount: unitDiscountAmount,
                subtotal: subtotal,
            }

            if (func_validation.isArrayNotEmpty(outletNames) &&
                (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "system"))) {
                obj["subRows"] = [{ outlets: outletNames }];
            }

            return obj;
        })
    }

    return (
        <div className="billOverview">
            <div className="billOverview-header">
                {/* Title */}
                <div className="billOverview-headerTitle pageHeaderTitle ">
                    Bill {invoiceNo}

                    {/* Close Icon */}
                    <img
                        className={"billOverview-headerTitle-closeIcon"}
                        src={ic_close}
                        alt={"Close icon"}

                        onClick={() => { if (func_validation.isFunction(props.updateParentState_visiblity)) props.updateParentState_visiblity(false); }}
                    />
                </div>

                {/* Account Detail */}
                <AccountOverviewDropdown
                    accountOverviewArray={accountOverviewArray}
                    isLoading={getSpecificInvoiceDetails_requesting}
                    isCursorHidden
                />

            </div>

            <div className="billOverview-body">
                <GeneralTable
                    columns={billOverviewColumns.getColumns()}
                    data={invoiceItems_formatted}
                    minRows={10}

                    getTableData={getSpecificInvoiceDetails}

                    isTableDataLoading={getSpecificInvoiceDetails_requesting}

                    isExpanderRequired isColumnResizeable
                    isTableOddRowsDarken isAllColumnWidthEqual
                />
            </div>

        </div>
    );
}
